// react
import React, { useEffect, useState } from 'react';
// components
import BookingHeader from '../components/bookingHeader';
import ProductModal from '../components/booking/productModal';
import UploadFile from '../components/uploadFile';
import QuestionModal from '../components/booking/questionModal';
import SelectTeacher from '../components/booking/selectTeacher';
// apis & store & utils
import { Select, Input, Radio, Button, Steps, Modal, message, Tag, Row, Col, Typography, Tabs, Rate } from 'antd';
import { addBooking, getCountNum, getTimeOfSubject, processTimeCheck, processTimeLock, evaluationReport, serveProductList, getSpSubjectTask, getEvaluationListTask, getUserInfoByTokenTask, getReportUrl } from '../api/request';
import { getValue, isPhone, isEvaluationjump, parseUrl } from '../utils';
import { ifRestrict, goSubscribeList } from './../utils/verify';
import { TEACHER_HEAD_IMG } from '../utils';
import { BOOKING_SCENE } from '../components/ViewUtils';
import { EvaluationPage } from '@gaodun.com/gui-pc';

// assets
import '../assets/css/booking.less';
import complete from '../assets/images/complete.svg';
import { QuestionCircleOutlined } from '@ant-design/icons';

const { Paragraph } = Typography;
const { TabPane } = Tabs;

/**
 * @description 预约信息提交页
 * @param {*} props
 * @returns {*} booking page
 */
const imgModalValueList = [
    {
        value: 1,
        defaultValue: 'http://simg01.gaodunwangxiao.com/uploadfiles/tmp/upload/202204/25/37b7d_20220425160728.png',
        activeValue: 'http://simg01.gaodunwangxiao.com/uploadfiles/tmp/upload/202204/25/be679_20220425160556.png', tip: '非常不满意'
    },

    {
        value: 2,
        defaultValue: 'http://simg01.gaodunwangxiao.com/uploadfiles/tmp/upload/202204/25/fff2f_20220425160741.png',
        activeValue: 'http://simg01.gaodunwangxiao.com/uploadfiles/tmp/upload/202204/25/bce90_20220425160631.png', tip: '不满意'
    },

    {
        value: 3,
        defaultValue: 'http://simg01.gaodunwangxiao.com/uploadfiles/tmp/upload/202204/25/d4744_20220425160756.png',
        activeValue: 'http://simg01.gaodunwangxiao.com/uploadfiles/tmp/upload/202204/25/7026a_20220425160645.png', tip: '一般'
    },

    {
        value: 4,
        defaultValue: 'http://simg01.gaodunwangxiao.com/uploadfiles/tmp/upload/202204/25/c050e_20220425160812.png',
        activeValue: 'http://simg01.gaodunwangxiao.com/uploadfiles/tmp/upload/202204/25/23504_20220425160703.png', tip: '满意'
    },

    {
        value: 5,
        defaultValue: 'http://simg01.gaodunwangxiao.com/uploadfiles/tmp/upload/202204/25/131b7_20220425160824.png',
        activeValue: 'http://simg01.gaodunwangxiao.com/uploadfiles/tmp/upload/202204/25/40615_20220425160715.png', tip: '非常满意'
    },
];


let userId = '';

const { evaluationReportId, is_back, service_name, saas_id, chapterId, sectionId, sourcesId, sourcesType } = parseUrl();


const Booking = (props) => {
    // 获取测评地址
    const [reportUrl, setReportUrl] = useState('');
    const getReportUrlById = async () => {
        const { data: { status, result } } = await getReportUrl({
            paperDataLogId: sourcesId,
            source: 0
        });
        if (status === 0) {
            setReportUrl(result);
        }
    };
    useEffect(() => {
        if (sourcesType === '2') {
            getReportUrlById();
        }
    }, [sourcesType]);


    const [questionnaire, setQuestionnaire] = useState(null); // 问卷信息
    const [newEvaluatioinVsbIndex, setNewEvaluatioinVsbIndex] = useState(-1); // 问卷信息

    // 科目列表
    const [subjects, setSubjects] = useState([]);

    // 选中科目
    const [selectedSubject, setSelectedSubject] = useState(undefined);
    const [selectedSubjectName, setSelectedSubjectName] = useState(undefined);

    // 二级科目
    const [twoSubjects, setTwoSubjects] = useState();
    // 选中的二级科目
    const [selectedTwoSubjects, setSelectedTwoSubjects] = useState(undefined);

    // 科目错误
    const [subjectError, setSubjectError] = useState(false);
    // 二级科目错误
    const [twoSubjectError, setTwoSubjectError] = useState(false);

    // 上课方式错误
    const [serviceTypeError, setServiceTypeError] = useState(false);

    // 时间列表数据源
    const [dateSource, setDateSource] = useState([]);

    // 日期列表
    const [dateList, setDateList] = useState([]);

    // 选中日期
    const [selectedDate, setSelectedDate] = useState(undefined);

    // 日期错误
    const [dateError, setDateError] = useState(false);

    // 时间段列表
    const [timeList, setTimeList] = useState([]);

    // 选中时间段
    const [selectedTime, setSelectedTime] = useState([]);

    // 时间段错误
    const [timeError, setTimeError] = useState(false);

    // 手机号码
    const [phone, setPhone] = useState('');

    // 手机号码错误
    const [phoneError, setPhoneError] = useState(false);
    const [phoneTypeError, setPhoneTypeError] = useState(false);

    // 步骤
    const [step, setStep] = useState(0);

    const { Step } = Steps;
    const { TextArea } = Input;

    // 上课方式
    const [courseType, setCourseType] = useState();

    // 上课方式
    const [courseTypeList, setCourseTypeList] = useState([]);

    // 问题描述
    const [question, setQuestion] = useState('');


    // 问题描述错误
    const [questionError, setQuestionError] = useState(false);

    // 文件相关
    const [fileList, setFileList] = useState([]);
    const [fileUrlListStr, setFileUrlListStr] = useState('');

    // 文件相关
    const [fileUrlListStrError, setFileUrlListStrError] = useState(false);

    // loading 状态
    const [loading, setLoading] = useState(false);

    // 存储要提交的数据
    const [projectId, setProjectId] = useState(0);
    const [selectSyllabus, setSelectSyllabus] = useState([]);


    const [latestBookingTime, setLatestBookingTime] = useState(0);

    //问题描述范例
    const [questionDemoVisible, setQuestionDemoVisible] = useState(false);
    // 测评地址链接
    const [evaluationReportLink, setEvaluationReportLink] = useState('');

    // 是否显示选择产品
    const [productModalVisible, setProductModalVisible] = useState(false);
    // 产品服务列表
    const [productList, setProductList] = useState(undefined);
    // 默认及选中的产品服务
    const [productData, setProductData] = useState(undefined);
    // 直播可提前多少分钟进入
    const [advanceMinute, setAdvanceMinute] = useState(0);
    // 超过多少分钟不能进去
    const [afterMinute, setAfterMinute] = useState(0);
    // 上限数
    const [upperLimit, setUpperLimit] = useState({
        isBookingOnline: 0, // 学员预约数是否有上线 0-没有 1-有
        bookingOnlineNum: 1, // 学员预约上线数
    });
    //选择老师
    const [selectTeacherVisible, setSelectTeacherVisible] = useState(false);
    //预约类型 0普通预约 1名师预约
    const [bookingType, setBookingType] = useState('0');
    //后台配置的预约类型 用来控制页面tab是否隐藏
    const [teachingType, setTeachingType] = useState('0');
    //名师预约选择的老师信息
    const [teacherInfo, setTeacherInfo] = useState({});
    //名师预约选择的时间信息
    const [teacherTimeInfo, setTeacherTimeInfo] = useState({});
    const bookingWay = {
        100529221: '电话',
        100529222: '直播',
        100529223: '面授'
    };

    //特殊团队ID 支持批量预约
    const teamId = ['100118104', '100118066'];

    const [isChecked, setIsChecked] = useState(false);

    const initNpsModal = async () => {


        let ret = await getEvaluationListTask({// 私教预约流程的 scence
            version: '体验监测V1.0',
            courseId: 0,
            productType: 4,
            businessUnitId: `202201${userId}`
        });
        if (ret.data.status === 0) {
            let questionnaireInfo = ret.data.result;
            if (questionnaireInfo.allowShow === 1) {   //1显示，0不显示
                setQuestionnaire(questionnaireInfo);
            }
        }
    };


    /**
     * @description 根据测评ID获取测评报告
     */
    const _evaluationReport = async () => {
        if (!evaluationReportId) return;
        try {
            const { data } = await evaluationReport({ evaluationReportId: evaluationReportId });
            data.result && data.result.evaluationReportUrl
                ? setEvaluationReportLink(data.result.evaluationReportUrl)
                : setEvaluationReportLink('');
        } catch (err) {
            setEvaluationReportLink('');
        }
    };
    /**
     * @description 获取产品服务列表
     */
    const getServeProductList = async () => {
        const serviceTeamId = props.match.params.id;
        const { data } = await serveProductList({ serviceTeamId });
        if (!data.status) {
            setProductList(data.result);
        }
    };
    /**
     * @description 获取SP对应的科目
     * @param {*} proData 
     */
    const getSubjectList = async (proData) => {
        const serviceTeamId = props.match.params.id;
        const productId = proData.productId;
        const version = proData.version !== null ? proData.version : undefined;
        const { data } = await getSpSubjectTask({ productId, version, serviceTeamId });
        if (data.status === 0) {
            setSubjects(getValue(() => data.result) || []);
            if (data.result && data.result.length === 1) {
                const sid = data.result[0].id;
                setSelectedSubject();
                const subjectItem = subjects.find((item) => {
                    return item.id === sid;
                });
                setSelectedSubjectName(getValue(() => subjectItem.name));
            }
        } else {
            setSubjects([]);
            message.error(data.message);
        }
        setTwoSubjects(undefined);
    };
    /**
     * @description 检查预约状态, 科目次数
     */
    const _getBookingSubjects = async () => {
        const serviceTeamId = props.match.params.id;
        const { data } = await getCountNum({ serviceTeamId });
        if (data.status) {
            Modal.info({
                title: data.message || data.info,
                okText: '确定'
            });
            return;
        }
        if (!data.status) {
            setUpperLimit({
                isBookingOnline: data.result.isBookingOnline,
                bookingOnlineNum: data.result.bookingOnlineNum
            });
            setLatestBookingTime(data.result.latestCancelTime);
            setAdvanceMinute(data.result.advanceMinute);
            setProductData(getValue(() => data.result.product ? data.result.product : undefined));
            setSubjects(getValue(() => data.result.subject) || []);
            setProjectId(getValue(() => data.result.projectId));
            setPhone(data.result.defaultPhone ? data.result.defaultPhone : '');
            // 处理上课方式
            const serviceType = getValue(() => data.result.serviceType) || '';
            const serviceTypeList = serviceType.split(',');
            setCourseTypeList(serviceTypeList);
            setCourseType(serviceTypeList.length === 1 ? serviceTypeList[0] : 0);
            setAfterMinute(data.result.afterMinute);
            const teachingTypeNow = data.result ? data.result.teachingType || '0' : '0';
            setTeachingType(teachingTypeNow);
            if (teachingTypeNow === '0' || teachingTypeNow === '1') {
                setBookingType(teachingTypeNow);
            }
        } else {
            message.warning(data.message || data.info);
        }
    };


    /**
     * @description 检查预约状态, 科目次数
     * @param {*} id
     * @param {*} courseTypeVal
     * @param {*} twoSubjectId
     */
    const _getSeatsList = async (id, courseTypeVal, twoSubjectId) => {
        const serviceTeamId = props.match.params.id;
        const subjectId = id;
        const { data } = await getTimeOfSubject({ serviceTeamId, subjectId, serviceType: courseTypeVal, twoSubjectId: twoSubjectId });
        if (data.status) {
            setDateList([]);
            if (bookingType === '0') {
                Modal.info({
                    title: data.message || data.info,
                    okText: '确定'
                });
            }
            return;
        }
        if (!data.status) {
            // 设置时间列表
            setDateSource(data.result.list);
            let dateListArr = data.result.list.map((item) => {
                return item;
            });
            setDateList(dateListArr);
        } else {
            if (bookingType === '0') {
                message.warning(data.message);
            }

        }
    };

    /**
     * @description 更改选择科目
     * @param {*} subject
     */
    const handleChangeSubject = (subject) => {
        // 改变选中态
        setSelectedSubject(subject);
        const subjectItem = subjects.find((item) => {
            return item.id === subject;
        });
        setSelectedSubjectName(getValue(() => subjectItem.name));
        setSelectedDate(undefined);
        setSelectedTime(undefined);
        setSelectedTwoSubjects(undefined); // 选中的二级科目重置
        setSelectSyllabus([]);
        setDateList([]);
        setCourseType(courseTypeList.length === 1 ? courseTypeList[0] : 0);
        setServiceTypeError(false);
        setTwoSubjectError(false);
        setDateError(false);
        setTimeError(false);
        if ((teachingType || '').includes('1')) {
            setTeacherTimeInfo({});
            setTeacherInfo({});
        }
        // 解除错误
        if (subjectError) {
            setSubjectError(false);
        }
        if (subjectItem.twoSubject && subjectItem.twoSubject.length !== 0) {
            setTwoSubjects(subjectItem.twoSubject);
            return;
        } else {
            setTwoSubjects(undefined);
        }
        // 获取上课时间
        if (courseTypeList.length === 1) {
            _getSeatsList(subject, courseType);
        }
    };
    /**
     * @description 更改选择二级科目
     * @param {*} twoSubject
     */
    const handleChangeTwoSubject = (twoSubject) => {
        const subjectItem = twoSubjects.find((item) => {
            return item.id === twoSubject;
        });
        setSelectedTwoSubjects(subjectItem);
        setCourseType(courseTypeList.length === 1 ? courseTypeList[0] : 0);
        setDateList([]);
        setSelectedDate(undefined);
        setSelectedTime(undefined);
        setSelectSyllabus([]);
        if ((teachingType || '').includes('1')) {
            setTeacherTimeInfo({});
            setTeacherInfo({});
        }
        // 解除错误
        if (twoSubjectError) {
            setTwoSubjectError(false);
        }
        // 获取上课时间 传入一级科目
        if (courseTypeList.length === 1) {
            _getSeatsList(selectedSubject, courseType, subjectItem.id);
        }
    };
    /**
     * @description 根据上课方式获取上课时间
     * @param {*} serviceType  上课方式
     */
    const handleChangeCourseType = (serviceType) => {
        if (!selectedSubject) {
            message.error('请选择科目');
            return;
        } else if (twoSubjects && !selectedTwoSubjects) {
            message.error('请选择二级科目');
            return;
        }
        // 解除错误
        if (serviceTypeError) {
            setServiceTypeError(false);
        }
        setCourseType(serviceType);
        setSelectedDate(undefined);
        setSelectedTime(undefined);
        if ((teachingType || '').includes('1')) {
            setTeacherTimeInfo({});
            setTeacherInfo({});
        }
        const twoSubjectId = selectedTwoSubjects ? selectedTwoSubjects.id : undefined;
        // 获取上课时间
        _getSeatsList(selectedSubject, serviceType, twoSubjectId);
    };

    /**
     * @description 变更日期
     * @param {*} date
     */
    const handleChangeDate = (date) => {
        // 变更则改变时间段列表
        const timeObject = dateSource.filter((item) => {
            return item.classDay === date;
        });
        // 解除错误
        if (dateError) {
            setDateError(false);
        }
        setSelectedTime(undefined);
        setTimeList(timeObject[0].timeList);
    };

    //判断是否选择上课方式
    const showErrorInfo = (e) => {
        if (!selectedSubject) {
            setSubjectError(true);
            return;
        }
        if (twoSubjects && !selectedTwoSubjects) {
            setTwoSubjectError(true);
            return;
        }
        if (!courseType) {
            setServiceTypeError(true);
            return;
        }
    };

    /**
     * @description 变更时间段
     * @param {*} time
     */
    const handleChangeTime = (time) => {
        if (time instanceof Array && time.length > 5) {
            message.error('预约时段不能超过5个');
            return;
        }
        //校验学员某个时间是否预约过
        let times = timeList.filter((item) => {
            return time && time.includes(item.times);
        });
        const promises = times.map((timeN) => processTimeCheck({
            projectId: projectId,
            subjectId: selectedSubject,
            serviceTeamId: props.match.params.id,
            startTime: `${selectedDate} ${timeN.times.split('-')[0]}`,
            endTime: `${selectedDate} ${timeN.times.split('-')[1]}`,
            serviceType: courseType,
            twoSubjectId: selectedTwoSubjects ? selectedTwoSubjects.id : undefined,
        }));
        Promise.all(promises).then((res) => {
            let flag = true;
            res.forEach((item) => {
                if (!(item.data.status === 0)) {
                    flag = false;
                    setSelectedTime(time);
                    setSelectedTime(undefined);
                    return message.warning(item.data.message || item.data.info);
                }
            });
            if (flag) {
                setSelectedTime(time);
                // 当前选中时段预约信息
                setSelectSyllabus(times);
            }
        }).catch((err) => {
        });
        // 解除错误
        if (timeError) {
            setTimeError(false);
        }
    };
    //过滤表情包
    const removeEmoji=(content) => {
        return content.replace(/(?:[\u2700-\u27bf]|(?:\ud83c[\udde6-\uddff]){2}|[\ud800-\udbff][\udc00-\udfff]|[\u0023-\u0039]\ufe0f?\u20e3|\u3299|\u3297|\u303d|\u3030|\u24c2|\ud83c[\udd70-\udd71]|\ud83c[\udd7e-\udd7f]|\ud83c\udd8e|\ud83c[\udd91-\udd9a]|\ud83c[\udde6-\uddff]|\ud83c[\ude01-\ude02]|\ud83c\ude1a|\ud83c\ude2f|\ud83c[\ude32-\ude3a]|\ud83c[\ude50-\ude51]|\u203c|\u2049|[\u25aa-\u25ab]|\u25b6|\u25c0|[\u25fb-\u25fe]|\u00a9|\u00ae|\u2122|\u2139|\ud83c\udc04|[\u2600-\u26FF]|\u2b05|\u2b06|\u2b07|\u2b1b|\u2b1c|\u2b50|\u2b55|\u231a|\u231b|\u2328|\u23cf|[\u23e9-\u23f3]|[\u23f8-\u23fa]|\ud83c\udccf|\u2934|\u2935|[\u2190-\u21ff])/g, '');
    };

    /**
     * @description 提交预约调用
     * 
     * @param { object } item //单个预约时间段详情
     */
    const _handlePostBooking = async (item) => {
        // 提交预约
        let params = {
            projectId: projectId,
            subjectId: selectedSubject,
            serviceTeamId: props.match.params.id,
            bookingDate: selectedDate,
            startTime: `${selectedDate} ${item.times.split('-')[0]}`,
            endTime: `${selectedDate} ${item.times.split('-')[1]}`,
            phone,
            serviceType: courseType,
            context: removeEmoji(question),
            pic: fileUrlListStr,
            productId: productData.productId,
            productVersion: productData.version !== null ? productData.version : undefined,
            orderNum: productData.crmOrderNum,
            productType: productData.productType,
            twoSubjectId: selectedTwoSubjects ? selectedTwoSubjects.id : undefined,
            bookingType,
            sourcesId: sourcesId,
            sourcesType: sourcesType
        };

        if (evaluationReportId) {
            // 0-自己 / 1-测评
            params.sourcesType = 1;
            params.sourcesId = +evaluationReportId;
            params.chapterId = +chapterId;
            params.sectionId = +sectionId;
            params.courseId = +saas_id;
        }

        const { data } = await addBooking(params);

        if (data.status) {
            return new Promise((resolve, reject) => {
                message.warning(data.message || data.info);
                reject(data.message);
                setLoading(false);
            });
        }
    };
    //名师预约逻辑
    const handleNextStepTeacher = async () => {
        if (!selectedSubject) {
            setSubjectError(true);
            return;
        }
        if (twoSubjects && !selectedTwoSubjects) {
            setTwoSubjectError(true);
            return;
        }
        if (!teacherInfo.teacherId) {
            return message.error('请选择老师');

        }
        if (!teacherTimeInfo.classDay) {
            return message.error('请选择预约时间');

        }
        if (!phone) {
            setPhoneError(true);
            return;
        }
        if (!isPhone(phone)) {
            setPhoneTypeError(true);
            return;
        }
        const { data } = await processTimeLock({
            projectId: projectId,
            subjectId: selectedSubject,
            serviceTeamId: props.match.params.id,
            startTime: `${teacherTimeInfo.classDay} ${teacherTimeInfo.times.split('-')[0]}`,
            endTime: `${teacherTimeInfo.classDay} ${teacherTimeInfo.times.split('-')[1]}`,
            serviceType: courseType,
            twoSubjectId: selectedTwoSubjects ? selectedTwoSubjects.id : undefined,
            bookingType,
            scheduleId: teacherTimeInfo.scheduleId
        });
        if (data.status !== 0) {
            return message.error(data.message);
        }
        setStep(1);
    };
    /**
     * @description 点击下一步
     */
    const handleNextStep = async () => {
        if (bookingType === '1') {
            handleNextStepTeacher();
            return;
        }
        // 表单校验
        if (!selectedSubject) {
            setSubjectError(true);
            return;
        }
        if (twoSubjects && !selectedTwoSubjects) {
            setTwoSubjectError(true);
            return;
        }
        if (!courseType) {
            setServiceTypeError(true);
            return;
        }
        if (!selectedDate) {
            setDateError(true);
            return;
        }
        if (!selectedTime) {
            setTimeError(true);
            return;
        }
        if (!phone) {
            setPhoneError(true);
            return;
        }
        if (!isPhone(phone)) {
            setPhoneTypeError(true);
            return;
        }

        let result = await ifRestrict(props.match.params.id);
        if (result !== 0) {
            return;
        }
        const promises = selectSyllabus.map((timeN) => processTimeLock({
            projectId: projectId,
            subjectId: selectedSubject,
            serviceTeamId: props.match.params.id,
            startTime: `${selectedDate} ${timeN.times.split('-')[0]}`,
            endTime: `${selectedDate} ${timeN.times.split('-')[1]}`,
            serviceType: courseType,
            twoSubjectId: selectedTwoSubjects ? selectedTwoSubjects.id : undefined,
            bookingType,
        }));
        Promise.all(promises).then((res) => {
            res.forEach((item) => {
                if (item.data.status !== 0) {
                    return message.error(item.data.message);
                } else {
                    setStep(1);
                }
            });
        });
    };

    /**
     * @description 点击上一步
     */
    const handlePrevStep = async () => {
        setStep(0);
    };

    /**
     * @description 存储文件列表URL
     * @param {*} val
     */
    const handleSetFileUrlListStr = (val) => {
        setFileUrlListStr(val);
        // 如果有文件 则关闭error
        if (val) {
            setFileUrlListStrError(false);
        }
    };

    /**
     * @description 存储文件列表
     * @param {*} files
     */
    const handleSetFileList = (files) => {
        setFileList(files);
    };
    const _handlePostBookingTeacher = async () => {
        // 提交预约
        let params = {
            projectId: projectId,
            subjectId: selectedSubject,
            serviceTeamId: props.match.params.id,
            bookingDate: teacherTimeInfo.classDay,
            startTime: `${teacherTimeInfo.classDay} ${teacherTimeInfo.times.split('-')[0]}`,
            endTime: `${teacherTimeInfo.classDay} ${teacherTimeInfo.times.split('-')[1]}`,
            phone,
            serviceType: courseType,
            context: removeEmoji(question),
            pic: fileUrlListStr,
            productId: productData.productId,
            productVersion: productData.version !== null ? productData.version : undefined,
            orderNum: productData.crmOrderNum,
            productType: productData.productType,
            twoSubjectId: selectedTwoSubjects ? selectedTwoSubjects.id : undefined,
            bookingType,
            scheduleId: teacherTimeInfo.scheduleId,
            sourcesId: sourcesId,
            sourcesType: sourcesType
        };
        if (evaluationReportId) {
            // 0-自己 / 1-测评
            params.sourcesType = 1;
            params.sourcesId = +evaluationReportId;
            params.chapterId = +chapterId;
            params.sectionId = +sectionId;
            params.courseId = +saas_id;
        }
        setLoading(true);
        const { data } = await addBooking(params);
        setLoading(false);
        if (data.status !== 0) {
            return message.error(data.message);
        }
        setStep(2);
        const successInfo = {
            courseType: courseType,
            selectedSubjectName: selectedSubjectName,
            selectedDate: teacherTimeInfo.classDay,
            selectedTime: teacherTimeInfo.times,
            phone: phone,
            selectedTwoSubjects: selectedTwoSubjects,
            upperLimit: upperLimit,
            advanceMinute: advanceMinute,
            afterMinute: afterMinute,
            latestBookingTime: latestBookingTime
        };
        sessionStorage.setItem('successInfo', JSON.stringify(successInfo));
    };
    /**
     * @description 点击提交预约
     */
    const handleConfirmStep = async () => {
        let result = await ifRestrict(props.match.params.id);
        if (result !== 0) {
            return;
        }
        // 表单校验，触发条件: 来源不是测评并且问题描述没有值
        if (sourcesType !== '2' && !evaluationReportId && !question) {
            setQuestionError(true);
            return;
        }

        //名师预约走名师预约逻辑
        if (bookingType === '1') {
            _handlePostBookingTeacher();
            return;
        }
        setLoading(true);
        // 提交预约
        Promise.all(selectSyllabus.map(i => _handlePostBooking(i))).then(
            () => {
                setLoading(false);
                setStep(2);
                const successInfo = {
                    courseType: courseType,
                    selectedSubjectName: selectedSubjectName,
                    selectedDate: selectedDate,
                    selectedTime: selectedTime,
                    phone: phone,
                    selectedTwoSubjects: selectedTwoSubjects,
                    upperLimit: upperLimit,
                    advanceMinute: advanceMinute,
                    afterMinute: afterMinute,
                    latestBookingTime: latestBookingTime
                };
                sessionStorage.setItem('successInfo', JSON.stringify(successInfo));
            }
        );
    };



    /**
     * @description 是否超过2小时
     * @param {String} time
     * @returns {Boolean} bool
     */
    // const isOverTwoHours = (time) => {
    //     const timeStr = time.substring(0, 16);
    //     const timeStamp = new Date(timeStr).getTime();
    //     return timeStamp - Date.now() > 2 * 3600 * 1000;
    // };

    /**
     * @description 是否超过4小时
     * @param {String} time
     * @returns {Boolean} bool
     */
    const isOverOneDay = (time) => {
        const timeStr = time.substring(0, 16);
        const timeStamp = new Date(timeStr).getTime();
        return timeStamp - Date.now() > latestBookingTime * 3600 * 1000;
    };

    // 获取周期类型
    const getCycle = (type, cycle) => {
        if (+cycle > 1) {
            return '本周期';
        }
        switch (type) {
            case 1:
                return '本天';
            case 2:
                return '本周';
            case 3:
                return '本月';
            default:
                return '';
        }
    };
    /**
     * 选择老师
     */
    const selectTeacherHandle = () => {
        if (!selectedSubject) {
            message.error('请选择科目');
            return;
        } else if (twoSubjects && !selectedTwoSubjects) {
            message.error('请选择二级科目');
            return;
        } else if (!courseType) {
            message.error('请选择上课方式');
            return;
        }
        setSelectTeacherVisible(true);
    };

    /**
     * @param {Object} teacherData
     * @param {Object} timeData
     * 确认选择老师和时间
     */
    const selectTeacherSureHandle = (teacherData, timeData) => {
        setTeacherInfo(teacherData);
        setTeacherTimeInfo(timeData);
        setSelectTeacherVisible(false);
    };

    /**
     * @param {String} v
     * 确认选择老师和时间
     */
    const bookingTypeChangeHandle = (v) => {
        setBookingType(v);
    };
    /* eslint-disable */

    /**
     * @description 生命周期 api请求
     */
    useEffect(async () => {

        const resInfo = await getUserInfoByTokenTask();
        const { data } = resInfo.data;
        userId = data.userId;

        if (sessionStorage.getItem('successInfo')) {
            const successInfo = JSON.parse(sessionStorage.getItem('successInfo'));
            setCourseType(successInfo.courseType);
            setSelectedSubjectName(successInfo.selectedSubjectName);
            setSelectedDate(successInfo.selectedDate);
            setSelectedTime(successInfo.selectedTime);
            setPhone(successInfo.phone);
            setSelectedTwoSubjects(successInfo.selectedTwoSubjects);
            setUpperLimit(successInfo.upperLimit);
            setAdvanceMinute(successInfo.advanceMinute);
            setAfterMinute(successInfo.afterMinute);
            setLatestBookingTime(successInfo.latestCancelTime);
            setStep(2);
            return;
        }
        _getBookingSubjects();
        _evaluationReport();
        getServeProductList();
        initNpsModal();
    }, []);

    useEffect(() => {
        if (evaluationReportId && (evaluationReportId != null)) {
            productData && _getCorresponSubject(productData);
        } else {
            productData && getSubjectList(productData);
        }
    }, [productData]);

    const selectProduct = (productData) => (
        <div className="form-item clear">
            <div className="item-label fl">选择产品：</div>
            {
                productData ?
                    <div className='item-input fl product'>
                        <h5>{productData.productName}</h5>
                        {productData.cycleType === 0 ?
                            <p>您当前可预约私教服务次数为<span>{productData.remainNum}</span>次</p> :
                            <p>{getCycle(productData.cycleType, productData.cycle)}您还有<span>{productData.remainNum}</span>次私教服务，所有次数将于<span>{productData.remainDay}</span>天后重置</p>}

                        <Button onClick={() => setProductModalVisible(true)}>更换</Button>
                    </div> :
                    <div className='item-input fl product'>
                        <h4>暂时没有可预约的产品哦</h4>
                        <Button onClick={() => setProductModalVisible(true)}>查看</Button>
                    </div>
            }

        </div>
    );

    const _getCorresponSubject = async (proData) => {
        const { data } = await getSpSubjectTask({
            productId: proData.productId,
            serviceTeamId: props.match.params.id,
            version: proData.version !== null ? proData.version : undefined,
            evaluationContentId: evaluationReportId
        });
        if (data.status === 0 && data.result && data.result.length > 0) {
            // setSelectedSubject(data.result[0].id)
            setSubjects(data.result);
        } else {
            setSubjects([]);
            // setSelectedSubject([])
            message.error(data.message);
        }
    }

    /**
     * @description 第一步表单
     */

    const formStepOne = (

        <div className="step-one-wrapper">
            {
                ((teachingType.includes('0') && teachingType.includes('1')) || (teachingType.includes('0') && teachingType.includes('1') && sourcesType === '2')) && (
                    <Tabs tabPosition="left"
                        activeKey={bookingType}
                        onChange={bookingTypeChangeHandle}
                    >
                        <TabPane tab="场次预约" key="0" />
                        <TabPane tab="师资预约" key="1" />
                    </Tabs>
                )
            }

            <div className="step-one-right-content-wrapper">
                {/* 选择产品 */}
                {selectProduct(productData)}
                {/* 科目 */}
                <div className="form-item clear">
                    <div className="item-label fl">科目：</div>
                    <div className="item-input fr">
                        <Select
                            onChange={(e) => handleChangeSubject(e)}
                            placeholder="请选择科目"
                            style={{ width: 354 }}
                            disabled={!productData}
                            value={selectedSubject}
                        >
                            {
                                subjects.map((item, key) => (
                                    <Select.Option
                                        key={key}
                                        value={item.id}
                                    >{item.name}</Select.Option>
                                ))
                            }
                        </Select>
                        {/* 科目选择信息 */}
                        <div className="item-error">{subjectError && '请选择科目'}</div>
                    </div>
                </div>
                {/* 二级科目 */}
                {
                    twoSubjects &&
                    <div className="form-item clear">
                        <div className="item-label fl">二级科目：</div>
                        <div className="item-input fr">
                            <Select
                                onChange={(e) => handleChangeTwoSubject(e)}
                                placeholder="请选择二级科目"
                                style={{ width: 354 }}
                                disabled={!productData}
                                value={selectedTwoSubjects ? selectedTwoSubjects.id : selectedTwoSubjects}
                            >
                                {
                                    twoSubjects.map((item, key) => (
                                        <Select.Option
                                            key={key}
                                            value={item.id}
                                        >{item.name}</Select.Option>
                                    ))
                                }
                            </Select>
                            {/* 科目选择信息 */}
                            <div className="item-error">{twoSubjectError && '请选择二级科目'}</div>
                        </div>
                    </div>
                }

                {/* 选择产品 */}
                {/* 上课方式 */}
                <div className="form-item clear" style={{ paddingBottom: 24 }}>
                    <div className="item-label fl">上课方式：</div>
                    <div className="item-input fl ml7" style={{ paddingLeft: 5 }}>
                        <Radio.Group
                            onChange={e => {
                                handleChangeCourseType(e.target.value);
                                setIsChecked(false);
                            }}
                            disabled={!productData}
                            value={courseType}
                        >
                            {
                                courseTypeList.map((item, key) => (
                                    <Radio
                                        key={key}
                                        value={item}
                                    >{bookingWay[item]}</Radio>
                                ))
                            }
                        </Radio.Group>
                    </div>
                    <div className="item-error checkbox">{serviceTypeError && '请选择上课方式'}</div>
                </div>
                {
                    bookingType === '1' &&
                    <div className="form-item clear" style={{ paddingBottom: 24, marginTop: -10 }}>
                        <div className="item-label fl">选择老师：</div>
                        <div className="item-input fl ml7" style={{ paddingLeft: 5 }}>
                            {
                                teacherInfo.teacherId ?
                                    <>
                                        <img style={{ width: '24px', height: '24px', borderRadius: '50%', marginRight: '4px' }} src={teacherInfo.picture || TEACHER_HEAD_IMG} />
                                        <span>{teacherInfo.teacherName}</span>
                                    </>
                                    : null
                            }

                            <Button ghost type="primary" size="small" style={{ marginLeft: '4px' }} onClick={selectTeacherHandle}>更换</Button>
                        </div>
                    </div>
                }

                {
                    bookingType === '0' ? <>
                        {/* 上课日期： */}
                        <div className="form-item clear">
                            <div className="item-label fl">上课日期：</div>
                            <div className="item-input fr">
                                <Select
                                    onChange={e => { handleChangeDate(e); setSelectedDate(e); }}
                                    onDropdownVisibleChange={(e) => { showErrorInfo(e) }}
                                    placeholder="请选择上课日期"
                                    style={{ width: 354 }}
                                    disabled={!productData}
                                    value={selectedDate}
                                >
                                    {
                                        dateList.map((date, key) => (
                                            <Select.Option
                                                disabled={!!date.isAppointmentFull}
                                                key={key}
                                                value={date.classDay}
                                            >{`${date.classDay} ${date.isAppointmentFull ? '已满' : ''}`}</Select.Option>
                                        ))
                                    }
                                </Select>
                                {/* 上课日期选择错误信息 */}
                                <div className="item-error">{dateError && '请选择上课日期'}</div>
                            </div>
                        </div>
                        {/* 上课时间 */}
                        <div className="form-item clear">
                            <div className="item-label fl">上课时间：</div>
                            <div className="item-input fr">
                                <Select
                                    mode={teamId.includes(props.match.params.id) ? 'multiple' : ''}
                                    onChange={e => { handleChangeTime(e); }}
                                    placeholder="请选择上课时间段"
                                    style={{ width: 354 }}
                                    disabled={!productData}
                                    value={selectedTime}
                                >
                                    {
                                        timeList.map((item, key) => (
                                            <Select.Option
                                                disabled={!item.hadBooked}
                                                key={key}
                                                value={item.times}
                                            >{item.times}</Select.Option>
                                        ))
                                    }
                                </Select>
                                {/* 上课时间段选择错误信息 */}
                                <div className="item-error">{timeError && '请选择上课时间段'}</div>
                            </div>
                        </div>
                    </> : <div className="form-item clear">
                        <div className="item-label fl">上课时间：</div>
                        <div className="item-input fr">
                            <Input style={{ width: 354 }} value={teacherTimeInfo.classDay ? `${teacherTimeInfo.classDay} ${teacherTimeInfo.times}` : ''} readOnly />
                            {/* 上课时间段选择错误信息 */}
                            <div className="item-error">{timeError && '请选择上课时间段'}</div>
                        </div>
                    </div>
                }


                {/* 手机号码 */}
                <div className="form-item clear">
                    <div className="item-label fl">手机号：</div>
                    <div className="item-input fr">
                        <Input
                            onChange={(e) => { setPhone(e.target.value); setPhoneError(false); setPhoneTypeError(false); }}
                            placeholder="请输入您的手机号"
                            style={{ width: 354 }}
                            disabled={!productData}
                            allowClear={true}
                            value={phone} />
                        {/* 手机号码信息 */}
                        <div className="item-error">{phoneError && '请输入您的手机号'}{phoneTypeError && '请输入正确的手机号'}</div>
                    </div>
                </div>
                {/* 操作按钮 */}
                <div className="form-btn-group">
                    <Button
                        className="next-step"
                        disabled={!productData}
                        onClick={() => handleNextStep()}
                        type="primary"
                    >下一步</Button>
                </div>
            </div>
        </div>
    );

    /**
     * @description 第二步表单
     */

    const formStepTwo = (
        <div>
            {
                (sourcesType !== '2' && !evaluationReportId) && <Paragraph>当前时间已为您预留5分钟，您可认真填写问题</Paragraph>
            }
            {
                (sourcesType === '2' || evaluationReportId) ?
                    <Paragraph style={{ textAlign: 'center' }}>
                        本次私教服务，老师将根据您此次测评结果进行辅导<br />
                        查看
                        {
                            sourcesType === '2' && reportUrl && (
                                <a target="_blank" href={reportUrl}>测评报告</a>
                            )
                        }
                        {
                            (sourcesType !== '2' && evaluationReportLink) && (
                                <a target="_blank" href={evaluationReportLink}>测评报告</a>
                            )
                        }
                    </Paragraph>
                    :
                    <>
                        <div className="form-item clear">
                            <div className="item-label fl questionUp">
                                <QuestionCircleOutlined style={{ marginRight: '2px' }} onClick={() => setQuestionDemoVisible(true)} />
                                问题描述：
                            </div>
                            <div className="item-input fl">
                                <TextArea
                                    maxLength={200}
                                    onChange={e => { setQuestion(e.target.value); setQuestionError(false); }}
                                    placeholder="请同学们务必参照问号处问题描述范例进行提问，且描述不可少于10个字哦。如若问题描述不清晰，老师将无法解答。"
                                    rows={4}
                                    style={{ width: 342 }}
                                    value={question} />
                                <div className="item-error">{questionError && '请输入您的问题'}</div>
                            </div>
                        </div>
                        <div className="form-item clear">
                            <div className="item-label fl questionUp" style={{ textAlign: 'right', width: '86px' }}>上传图片：</div>
                            <div
                                className="item-input ml6 fl"
                                style={{ width: 338 }}
                            >
                                <UploadFile
                                    fileList={fileList}
                                    parentFileList={handleSetFileList.bind(this)}
                                    parentFileUrlListStr={handleSetFileUrlListStr.bind(this)} />
                                <div className="item-error">{fileUrlListStrError && '请上传图片'}</div>
                            </div>
                        </div>
                    </>
            }
            {/* 操作按钮 */}
            <div className="form-btn-group">
                <Button
                    className="prev-step"
                    loading={loading}
                    onClick={() => handleConfirmStep()}
                    type="primary"
                >提交预约</Button>
                <Button
                    className="next-step"
                    onClick={(e) => handlePrevStep(e)}
                >上一步</Button>
            </div>

        </div>
    );

    /**
     * @description 第三步表单
     */

    const formStepThree = (
        <div>
            <img src={complete} />
            <div className="complete-title">预约成功</div>
            <div className="complete-tips">
                {bookingWay[courseType] === '直播'
                    ? [<p>您可提前15分钟进入教室，不要迟到哦~</p>, <p>为了给您更好的服务体验，请注意直播间的设备要求</p>]
                    : <p>私教老师将于开课前2个工作日内联系您，保持手机畅通</p>}</div>
            <div className="complete-info">
                <Row gutter={8}>
                    <Col span={bookingWay[courseType] === '直播' ? 13 : 24}>
                        <div className="complete-info-label">上课科目：{selectedSubjectName}{selectedTwoSubjects ? `-${selectedTwoSubjects.name}` : null}</div>
                        <div className="complete-info-label">上课日期：{bookingType === '1' ? teacherTimeInfo.classDay : selectedDate}</div>
                        <div className="complete-info-label">
                            <span>上课时间：</span>
                            {
                                bookingType === '1' ? <div>{teacherTimeInfo.times}</div> :
                                    <div>
                                        {
                                            selectedTime instanceof Array ?
                                                selectedTime.map(
                                                    (time, key) =>
                                                    (
                                                        <Tag
                                                            color="green"
                                                            key={key}
                                                        >
                                                            {time}
                                                        </Tag>
                                                    )
                                                ) :
                                                (
                                                    selectedTime
                                                )
                                        }
                                    </div>
                            }
                        </div>
                        <div className="complete-info-label">手机号码：{phone}</div>
                        <div className="complete-info-label">上课方式：{bookingWay[courseType]}</div>
                        {
                            bookingType == '1' && <div className="complete-info-label">授课老师：{teacherInfo.teacherName}</div>
                        }

                    </Col>
                    {
                        bookingWay[courseType] === '直播'
                            ?
                            <Col span={11}>
                                <div className="complete-info-label">PC: win7及以上版本</div>
                                <div className="complete-info-label">MAC: macOS 10.11及以上版本</div>
                                <div className="complete-info-label">移动端: 高顿网校APP</div>
                                <div className="complete-info-label">浏览器: Chrome内核浏览器</div>
                            </Col>
                            : null
                    }
                </Row>
            </div>
            {questionnaire &&
                <div className="nps-modal-img-box">
                    <div className='nps-text'>
                        【私教辅导】满意度评价
                    </div>
                    {
                        imgModalValueList.map(item => (
                            <img
                                key={item.value}
                                src={item.defaultValue}
                                onClick={() => {
                                    setNewEvaluatioinVsbIndex(item.value);
                                }}
                            />
                        ))
                    }
                </div>
            }
            {
                !evaluationReportId && sourcesType !== '2' && (
                    <div className="form-btn-group">
                        <Button
                            className="prev-step"
                            onClick={() => {
                                if (sessionStorage.getItem('successInfo')) {
                                    sessionStorage.removeItem('successInfo')
                                }
                                window.location.reload()
                            }}
                        >再次预约</Button>
                    </div>
                )
            }
        </div>
    );

    /**天脑测评 */
    const getSkyHeadView = () => (
        <div className='booking-tips'>
            <div className="tips-title">私教预约说明</div>
            <div className="tips-subtitle">
                （1）请勿屯课：
            </div>
            <div className="tips-content">
                {upperLimit.bookingOnlineNum > 0
                    ?
                    `测一节，约一节，是最高效的学习方式哦~为保障学习效果，请勿屯课！当您手中待上课的数量超过${upperLimit.bookingOnlineNum}节时，需先上完至少一节私教课以后，再进行预约。`
                    :
                    '测一节，约一节，是最高效的学习方式哦~为保障学习效果，请勿屯课！'
                }
            </div>
            <div className="tips-subtitle">
                （2）按时上课：
            </div>
            <div className="tips-content">
                {`您最早可提前15分钟进入教室，上课时间开始后的${advanceMinute}分钟内未进入直播教室，视为旷课，自动放弃本次辅导服务。`}
            </div>
            <div className="tips-subtitle">
                （3）取消预约：
            </div>
            <div className="tips-content">
                {`本次预约周期内，距上课时间>${latestBookingTime}h，取消预约会返还私教预约服务次数（注意：系统已重置预约次数后，取消预约不会再次返还服务次数）；距上课时间＜${latestBookingTime}h，不允许取消预约`}
            </div>
        </div>
    );

    const BookingViewLeft = (
        <div className="booking-wrapper-left fl">
            <div className="booking-left-title">
                {
                    is_back && sourcesType !== '2' &&
                    <a onClick={() => isEvaluationjump()}>
                        <svg t="1629943879231" className="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="2582" width="200" height="200"><path d="M765.832 1017.314c-10.21 0-20.39-3.554-28.552-10.692L229.647 536.184a34.997 34.997 0 0 1 0-52.495L737.28 13.252a42.737 42.737 0 0 1 56.56 0c15.813 14.276 15.813 38.25 0 52.495L314.76 509.68l479.08 443.934c15.813 14.276 15.813 38.25 0 52.495a41.562 41.562 0 0 1-28.008 11.204z" fill="#3F3F3F" p-id="2583"></path></svg>
                    </a>
                }

                <h3>{service_name}</h3>
                <div className='subscribe-list' onClick={() => goSubscribeList(props.match.params.id)}>
                    <img src={require('./../assets/images/notes-clock.png')} />
                    <span>预约记录</span>
                </div>
            </div>
            <div>
                {/* 进度条  */}
                <div className="booking-progress">
                    <Steps
                        current={step}
                    >
                        <Step key={0} title="填写信息" />
                        <Step key={1} title="提交问题" />
                        <Step key={2} title="预约成功" />
                    </Steps>
                </div>


                {/* Form 表单 */}
                <div className="booking-form">
                    {/* 第一步 */}
                    {
                        step === 0 ? formStepOne : step === 1 ? formStepTwo : formStepThree
                        //formStepTwo
                    }
                </div>
                {/* 底部说明 */}
                {
                    (sourcesType === '2' || evaluationReportId) ? (getSkyHeadView()) : (
                        <div className="booking-tips">
                            <div className="tips-title">私教预约说明</div>
                            {
                                upperLimit.isBookingOnline === 1 ?
                                    <>
                                        <div className="tips-subtitle">私教预约手持数限制规则</div>
                                        <div className="tips-content">学员最大待上课数为：{upperLimit.bookingOnlineNum}节，
                                            待上课数超过{upperLimit.bookingOnlineNum}节后，将无法预约私教服务，取消已预约服务或私教服务结束后(该团队下待上课数≤限制数)仍可再次预约
                                        </div>
                                    </> :
                                    null
                            }
                            {
                                bookingWay[courseType] === '直播'
                                    ? [<div className="tips-subtitle">直播服务规则</div>,
                                    <><div className="tips-content">同学可提前{advanceMinute}分钟进入教室，请同学按照约定时间准时进入教室。</div>
                                        <div className="tips-content">超过{afterMinute}分钟未进入直播教室，视为放弃本次辅导服务，同学将无法进入教室。</div></>]
                                    : null
                            }
                            <div className="tips-subtitle">取消/改约服务规则</div>
                            <div className="tips-content">本次预约周期内，距上课时间大于{latestBookingTime}h，取消预约会返还私教预约服务次数（注意：系统已重置预约次数后，取消预约不会再次返还服务次数）；距上课时间＜{latestBookingTime}h，不允许取消预约</div>
                        </div>
                    )
                }

            </div>
        </div>
    );
    // 待评价详情modal 已经评价详情
    const BookingDetailModal = (
        <Modal
            footer={null}
            maskClosable={false}
            onCancel={() => setNewEvaluatioinVsbIndex(-1)}
            title="告诉我们真实的评价，我们会为您提供更好的服务！"
            visible={newEvaluatioinVsbIndex > 0}
            width={620}
        >
            <EvaluationPage
                firstClickIndex={newEvaluatioinVsbIndex}
                buttonPosition="right"
                buttonText="提交评价"
                gotoEvaluation={() => {
                }}
                onSubmit={() => {
                    setNewEvaluatioinVsbIndex(-1)//隐藏评价
                    setQuestionnaire(null);//隐藏 点击的图标
                }}
                businessUnitId={`202201${userId}`}
                evaluationType={3}
                productType={4}
                scene={BOOKING_SCENE.selfFunction} />
        </Modal>
    );


    const BookingView = (
        <div className="booking-wrapper clear">
            {/* 左侧 */}
            {BookingViewLeft}
        </div>
    );

    const onChangeModal = () => {
        setQuestionDemoVisible(false);
    }
    return (
        <div className="booking-container">
            {/* 头部 */}
            <BookingHeader />
            {/* 内容 */}
            {BookingView}
            {/* 选择产品 */}
            {productList && <ProductModal
                productModalVisible={productModalVisible}
                productList={productList}
                selectProductData={productData}
                productData={(data) => {
                    setProductData(data)
                    setSelectedSubject(undefined);
                    setSelectedSubjectName(undefined);
                }}
                productHandleCancel={(pData) => {
                    setProductModalVisible(false);
                    if (pData && productData && pData.productId === productData.productId) {
                        getSubjectList(productData);
                    }
                }} />}
            <QuestionModal
                latestBookingTime={latestBookingTime}
                questionDemoVisible={questionDemoVisible}
                onChangeModal={() => onChangeModal()}
                keyValue={1} />
            {
                selectTeacherVisible && (
                    <SelectTeacher
                        projectId={projectId}
                        subjectId={selectedSubject}
                        isChecked={isChecked}
                        twoSubjectId={selectedTwoSubjects ? selectedTwoSubjects.id : undefined}
                        serviceTeamId={props.match.params.id}
                        selectTeacherVisible={selectTeacherVisible}
                        onChecked={(checked) => {
                            setIsChecked(checked);
                        }}
                        serviceType={courseType}
                        teacherInfo={teacherInfo}
                        teacherTimeInfo={teacherTimeInfo}
                        onSelectTeacherCancel={() => setSelectTeacherVisible(false)}
                        onSelectTeacherSure={selectTeacherSureHandle}
                    />
                )

            }

            {
                newEvaluatioinVsbIndex > 0 && BookingDetailModal
            }
        </div>
    );
};

export default Booking;